import React, { CSSProperties } from "react";
import { packBy } from "../../lib";

export function XPackBy<T>({
  children,
  packSize,
  lineStyle,
  style,
  gap,
}: {
  packSize: number;
  style?: CSSProperties;
  lineStyle?: CSSProperties | ((line: React.ReactNode[]) => CSSProperties);
  children: React.ReactNode[];
  gap?: number;
}) {
  const packs = packBy(children, packSize);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap,
        ...style,
      }}
    >
      {packs.map((pack, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            gap,
            ...(typeof lineStyle === "function" ? lineStyle(pack) : lineStyle),
          }}
        >
          {pack}
        </div>
      ))}
    </div>
  );
}
